export default __webpack_public_path__ + "images/c500ba7c1f9712f1061d3d66389bc114-tennis.webp";